/**
 *
 * @author Matthew Rawson @ 14/08/2018 15:00
 * @description
 * @notes
 * - Left as class to future proof
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import querystring from "querystring"
import {withRouter} from "react-router-dom"
import {withApollo} from "react-apollo"

import getId from "@irati/utils/id"
import {insGlobalMutation} from "@irati/insights/apollo/client/mutation/insGlobal"
import {PLACEHOLDER_SCHEDULE_ID} from "@irati/insights/constants/schedule"
import {insWizardMutation} from "@irati/insights/apollo/client/mutation/InsWizard"

import EditController from "../../../components/Wizard/Edit/EditController"
import sitemap from "../../sitemap"

class Step2 extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired
  }

  componentDidMount() {
    this.saveRequiredParamsToState()
  }

  componentWillUnmount() {
    const {client} = this.props
    const variables = {params: {cycleId: null, interestId: null}}
    client.mutate({mutation: insGlobalMutation, variables})
  }

  saveRequiredParamsToState = () => {
    const {
      client,
      location: {search}
    } = this.props
    const {scheduleId, interestId = null} = querystring.parse(search.replace("?", ""))
    const cycleId = scheduleId || PLACEHOLDER_SCHEDULE_ID
    const variables = {params: {cycleId, interestId}}
    client.mutate({mutation: insGlobalMutation, variables})
    const wizardVariables = {
      isEditMode: false,
      prevURL: sitemap.wizardStep1.url,
      nextURL: sitemap.wizardStep3.url
    }
    client.mutate({mutation: insWizardMutation, variables: {params: wizardVariables}})
  }

  render() {
    const idNamespace = getId("Step2", this.props, {force: true})
    return <EditController id={idNamespace} />
  }
}

export default withRouter(withApollo(Step2))
